module.exports = __webpack_public_path__ + "img/goods-4.69b264ba.png";